import { useSelector } from 'react-redux';
import { IRootState } from '@state/reducers/Reducers';
import { FeatureOption } from '@utils/pageConfig/Types';
import { shouldLimitProductGroup } from '@utils/exploreUtils/ExploreUtils';

const useLimitProductGroup = (noOfAppliedPG: number, feature: FeatureOption, segmentBy?: FeatureOption) => {
  const { totalSubscriptionPgs: totalPGs } = useSelector((state: IRootState) => state.availabilityPg);

  return shouldLimitProductGroup(noOfAppliedPG, totalPGs, feature, segmentBy);
};

export default useLimitProductGroup;
